<div class="header-wrap d-flex align-items-center"
     [class.header-theme]="!fillBackground"
     [class.bg-primary]="fillBackground">
  <i class="back-btn-icon icon-chevron-left font-md"
     *ngIf="!closeableView && showBackBtn"
     (click)="onBack.emit()"></i>

  <div class="w-100 d-flex justify-content-center"
       [class.ps-5]="!showBackBtn">
    <ng-content></ng-content>
  </div>

  <i class="open-menu-icon icon-burger-menu font-2xl"
     *ngIf="!closeableView"
     (click)="showMenu = true"></i>

  <i class="icon-close font-xl"
     *ngIf="closeableView"
     (click)="onClose.emit()"></i>
</div>

<mobile-menu
  *ngIf="showMenu"
  [fillBackground]="fillBackground"
  (onClose)="showMenu = false">
  <ng-content select=".ng-content-mobile-menu-items"></ng-content>
</mobile-menu>
